import React, { useContext } from "react";
import { makeStyles } from "@material-ui/core/styles";
import Drawer from "@material-ui/core/Drawer";
import Billetera from "../../../components/Billetera";
import { MobileContext } from "../Mobile";

const drawerWidth = "100vw";

const useStyles = makeStyles(theme => ({
  drawer: {
    width: drawerWidth,
    flexShrink: 0
  },
  drawerPaper: {
    width: drawerWidth,
    backgroundColor: "#fafafa"
  }
}));

const BilleteraView = () => {
  const classes = useStyles();
  const { billeteraOpen, onCloseBilletera } = useContext(MobileContext);

  return (
    <>
      <Drawer
        className={classes.drawer}
        open={billeteraOpen}
        anchor="right"
        classes={{
          paper: classes.drawerPaper
        }}
      >
        <Billetera onBack={onCloseBilletera} />
      </Drawer>
    </>
  );
};

export default BilleteraView;
